import { apiWrapper } from 'ccs-ui-components';
import { IPatternDefinition } from '../../../models';

const headersInstance = () => ({
  'Ocp-Apim-Subscription-Key':
    process.env.REACT_APP_API_OCP_APIM_SUBSCRIPTION_KEY ?? ''
});

interface ISourceDetailsResponse {
  identifier: any,
  sourceName: string,
  replyTimeout: string,
  replyTopicName: string
  configJson: {
    requestSpecJson: string,
    responseSpecJson: string
  },
  eventName: string,
  eventVersion: number | undefined,
  patterns: IPatternDefinition[]
}

/**
 * Custom hook to call source registry name validation api
 * @returns promise
 */
const getSourceDetails = () => {
  async function callGetSourceDetailsApi(sourceName: string, version: string) {
    const { responseBody, isError, error } = await apiWrapper.get<ISourceDetailsResponse>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_SOURCE_REGISTRY_URL}/sources/${sourceName}/version/${version}`,
      headersInstance()
    );

    if (isError) {
      throw error;
    }

    return { data: responseBody };
  }

  const fetchSourceDetails = (sourceName: string, version: string) => callGetSourceDetailsApi(sourceName, version);

  return { fetchSourceDetails };
};

export default getSourceDetails;
